import { translate } from '@portal/services/i18n';

export enum UserImpersonationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export const UserImpersonationStatusArray = [
  {
    value: UserImpersonationStatus.PENDING,
    name:
      translate('PAGES.AUTH.MULTI_ACCESS_SELECTION.STATUS.PENDING') ||
      'Pendente',
  },
  {
    value: UserImpersonationStatus.ACCEPTED,
    name:
      translate('PAGES.AUTH.MULTI_ACCESS_SELECTION.STATUS.ACCEPTED') || 'Ativa',
  },
  {
    value: UserImpersonationStatus.REJECTED,
    name:
      translate('PAGES.AUTH.MULTI_ACCESS_SELECTION.STATUS.REJECTED') ||
      'Inativa',
  },
];

export const getUserImpersonationStatus = (status: string) => {
  return (
    UserImpersonationStatusArray.find((o) => o.value === status)?.name || status
  );
};

export const getUserImpersonationStatusColor = (status: string) => {
  switch (status) {
    case UserImpersonationStatus.ACCEPTED:
      return '#2ecc71';
    case UserImpersonationStatus.PENDING:
      return '#f39c12';
    case UserImpersonationStatus.REJECTED:
      return '#e74c3c';
    default:
      return '#919191';
  }
};
